// extracted by mini-css-extract-plugin
module.exports = {"menuBody":"Menuoption_menuBody__3QZBz","menuIcon":"Menuoption_menuIcon__3lCkd","menuContent":"Menuoption_menuContent__1bZq6"};